module.exports = __webpack_public_path__ + "img/exclamation_gold.9bd48fcd.svg";